import { Link, isMatch, useMatches } from '@tanstack/react-router';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/common/components/modules/breadcrumb';

interface LoaderData {
  crumb?: string;
  name?: string;
}

function NavBreadcrumb() {
  const matches = useMatches();
  const matchesWithCrumbs = matches.filter(
    (match) => isMatch(match, 'loaderData.crumb') || isMatch(match, 'loaderData.name'),
  );

  const items = matchesWithCrumbs.map(({ fullPath, params, loaderData }) => {
    return {
      fullPath,
      params,
      label: (loaderData as LoaderData)?.crumb ?? (loaderData as LoaderData)?.name,
    };
  });

  return (
    <Breadcrumb data-testid='nav-breadcrumb'>
      <BreadcrumbList>
        {items.map((item, index) => (
          <BreadcrumbItem key={item.fullPath}>
            <Link
              to={item.fullPath}
              params={item.params}
              className={`breadcrumb-link ${index < items.length - 1 ? 'text-content-accent' : 'font-semibold text-content-neutral-primary'}`}
            >
              {item.label}
            </Link>
            {index < items.length - 1 && <BreadcrumbSeparator />}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}

export { NavBreadcrumb };
